<template>
    <div class="search_page">
        <Header />
        <div class="container">
            <div class="search_line">
                <input type="text">
                <img src="../assets/images/icon_search_cancel.svg" />
                <img src="../assets/images/icon_search_black.svg" />
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Search',
        pageCategory: '',
        components: {
            Header,
            Footer,
    },
    data(){
        return{
            isShowPopup : true
        }
    }
}
</script>